import { mount } from 'svelte';
import App from './App.svelte';

import './styles/spacing-l-plus.css';
import './app.css';

if (import.meta.env.MODE === 'inspect') {
	performance.mark('shelly:performance:startup-start');
	void import('../scripts/performance/runtime-marks').then(({ startRuntimeMeasurements }) => {
		startRuntimeMeasurements();
	});
}

const app = mount(App, {
	target: document.body,
});

export default app;
